<template>
  <div style="height:93%">
    <div slot="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/orders/orderList' }"
          >{{$t('laund.laund1')}}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{$t('router.router9')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="page-container">
      <div style="width: 840px; margin: 100px auto">
        <div class="item">
          <img
            src="../../assets/images/setting/p0.png"
            alt=""
            style="float: left; margin-right: 10px"
          />
          <span class="item1">{{$t('changeAccount.changeAccount2')}}</span>
          <span class="item2"
            >{{$t('changeAccount.changeAccount3')}}：{{ bingingData.email }}，{{$t('changeAccount.changeAccount4')}}</span
          >
          <router-link to="/changeEmail" class="item3">{{$t('changeAccount.changeAccount5')}}</router-link>
        </div>
        <el-divider></el-divider>
        <div class="item">
          <img
            src="../../assets/images/setting/p0.png"
            alt=""
            style="float: left; margin-right: 10px"
          />
          <span class="item1">{{$t('changeAccount.changeAccount32')}}</span>
          <span class="item2"
            >{{$t('changeAccount.changeAccount32')}}：{{
              bingingData.phoneNumber ? `${bingingData.phoneNumber}，` : ""
            }}{{$t('changeAccount.changeAccount33')}}</span
          >
          <router-link to="/changePhone" class="item3">{{$t('changeAccount.changeAccount34')}}</router-link>
        </div>
        <el-divider></el-divider>
        <div class="item">
          <img
            src="../../assets/images/setting/p0.png"
            alt=""
            style="float: left; margin-right: 10px"
          />
          <span class="item1">{{$t('changeAccount.changeAccount6')}}</span>
          <span class="item2">{{$t('changeAccount.changeAccount7')}}</span>
          <router-link to="/changePassword" class="item3">{{$t('changeAccount.changeAccount8')}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.item1 {
  float: left;
  font-size: 20px;
  width: 170px;
}
.item2 {
  float: left;
  width: 500px;
  font-size: 16px;
  color: #999999;
}
.item3 {
  color: #6ea0d0;
  font-size: 16px;
  text-decoration: none;
}
</style>

<script>
// npm install v-distpicker --save
export default {
  data() {
    return {
      bingingData: {
        phoneNumber: "",
        email: "",
      },
    };
  },
  methods: {
    async getUserInfo() {
      const { data: res } = await this.$http.get("customer/getCustomerInfo");
      if (res.code == 200) {
        console.log(res);
        this.bingingData.phoneNumber = res.data.mobileNumber;
        this.bingingData.email = res.data.emailAddress;
      } else {
        this.$message({
          message: res.message,
          type: "error",
        });
      }
    },
  },
  created() {
    this.getUserInfo();
  },
};
</script>